const findStringThroughChildren = (object: any): string => {
  if (typeof object === 'string') {
    return object;
  }

  if (typeof object?.props?.children === 'string') {
    return object?.props?.children;
  }

  if (
    typeof object?.props?.children?.length === 'number' &&
    typeof object?.props?.children[1] === 'string'
  ) {
    return object?.props?.children[1];
  }

  if (
    typeof object?.props?.children?.length === 'number' &&
    typeof object?.props?.children[1] === 'object'
  ) {
    findStringThroughChildren(object?.props?.children[1]);
  }

  return '';
};

export default findStringThroughChildren;
